import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import CloseButton from 'reservations/base/components/CloseButton';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface Props extends ModalProps {
  title: string;
  content: string | React.ReactNode;
}

export default function BaseModal({
  isOpen,
  onClose,
  title,
  content,
  children
}: React.PropsWithChildren<Props>) {
  return (
    <Dialog onClose={onClose} aria-labelledby="modal" open={isOpen}>
      <DialogContent sx={{ pt: 0, pb: 1 }}>
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <DialogTitle sx={{ pl: 0 }}>{title}</DialogTitle>
          </Grid>
          <Grid item sx={{ ml: 'auto' }}>
            <CloseButton onClick={onClose} />
          </Grid>
        </Grid>

        {typeof content === 'string' ? (
          <DialogContentText>{content}</DialogContentText>
        ) : (
          content
        )}
        <DialogActions sx={{ px: 0, pt: 2 }}>{children}</DialogActions>
      </DialogContent>
    </Dialog>
  );
}
